import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import DtoListItemCompanyFollowUpRecord_CompanyFollowUpRecordMethod from "./DtoListItemCompanyFollowUpRecord_CompanyFollowUpRecordMethod";
import { EnumCompanyFollowUpRecordStatus, EnumCompanyFollowUpRecordStatusOption } from "./EnumCompanyFollowUpRecordStatus";

/**
 * 跟进记录分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemCompanyFollowUpRecord extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 计划编号
     */
    Code?: string;
    /**
     * 客户企业
     */
    CustomerLabel?: string;
    /**
     * 跟进方式
     */
    Methods?: DtoListItemCompanyFollowUpRecord_CompanyFollowUpRecordMethod[];
    /**
     * 计划跟进时间
     */
    PlanFollowUpTime?: Date;
    /**
     * 跟进人
     */
    FollowUpPersonLabel?: string;
    /**
     * 超链接文本
     */
    LinkLabel?: string;
    /**
     * 超链接
     */
    Link?: string;
    /**
     * 状态
     */
    Status?: EnumCompanyFollowUpRecordStatus;
    /**
     * 客户企业Id
     */
    CustomerId?: string;
    /**
     * 跟进人
     */
    FollowUpPersonId?: string;
}

/**
 * 跟进记录分页列表-项-表单校验
 */
export const DtoListItemCompanyFollowUpRecordRules = {
}

/**
 * 跟进记录分页列表-项-设置项
 */
export const DtoListItemCompanyFollowUpRecordMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Code",
    Label: "计划编号",
  },
  {
    Prop: "CustomerLabel",
    Label: "客户企业",
  },
  {
    Prop: "Methods",
    Label: "跟进方式",
  },
  {
    Prop: "PlanFollowUpTime",
    Label: "计划跟进时间",
    MaxWidth: "150px",
    Pipe: EnumPipe.Time,
  },
  {
    Prop: "FollowUpPersonLabel",
    Label: "跟进人",
  },
  {
    Prop: "Link",
    Label: "超链接",
    Customize: true,
  },
  {
    Prop: "Status",
    Label: "状态",
    Pipe: EnumPipe.Enum,
    Options: EnumCompanyFollowUpRecordStatusOption,
  },
]
